import angular from 'angular';
import moment from 'moment-timezone';

module.exports = angular.module('common.filters.days-from-now', [])
.filter('daysFromNow', function() {
  return function(m) {
    const days = moment().diff(moment(m), 'days');
    const pluralizedDay = Math.abs(days) == 1 ? 'day' : 'days';
    var suffix = '';
    var prefix = '';
    if (days != 0) {
      if (days < 0) {
        suffix = '';
        prefix = 'in';
      } else if (days > 0) {
        suffix = 'ago';
        prefix = '';
      }
    }
    return [prefix, Math.abs(days), pluralizedDay, suffix].join(' ').trim();
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/days-from-now.js
 **/